export const MONTHS_LEFT = 'months,';
export const DAYS_LEFT = 'days left';
export const CAMPAIGN_CLOSED_MESSAGE = 'Campaign closed';
export const FEW_DAYS_LEFT_MARK = 3;
